import React, { PropsWithChildren } from 'react'
import CookieConsent from 'react-cookie-consent'
import '@/styles/index.scss'
import Header from '../components/header'
import Footer from '../components/footer'
import { Link } from 'gatsby'

type Props = {
  children: React.ReactNode
}

function Layout({ children }: PropsWithChildren<Props>) {
  const style = {
    background: '#fff',
    maxWidth: '1000px',
    left: '50%',
    transform: 'translateX(-50%)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
    alignItems: 'center',
    color: '#333',
  }
  const buttonStyle = {
    background: '#30a8fb',
    color: '#fff',
    borderRadius: '4px',
  }
  const declineButtonStyle = {
    background: '#fff',
    color: '#30a8fb',
    border: '1px solid #30a8fb',
    borderRadius: '4px',
  }

  return (
    <div className="layout">
      <Header />
      <main className="main">{children}</main>
      <Footer />
      <CookieConsent
        location="bottom"
        enableDeclineButton
        buttonText="同意する"
        declineButtonText="同意しない"
        cookieName="cookieAccept"
        cookieValue={true}
        buttonClasses={'cookie-banner__btn'}
        declineButtonClasses={'cookie-banner__btn'}
        containerClasses={'cookie-banner'}
        style={style}
        buttonStyle={buttonStyle}
        declineButtonStyle={declineButtonStyle}
        expires={365}
      >
        このウェブサイトでは、サイトの利便性の向上を目的にCookieを取得します。取得にご同意いただける場合は「同意する」ボタンをクリックしてください。詳細は個人情報保護方針の
        <a
          href={'https://trial-holdings.inc/legal/privacy-policy/#privacy7'}
          target="_blank"
          rel="noreferrer noopener"
          className="cookie-banner__link"
        >
          「第7条（Cookieの利用）」
        </a>
        をご覧ください。
      </CookieConsent>
    </div>
  )
}

export default Layout
